import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Skeleton from '@jimmyboys/liita-ui/dist/components/Skeleton'
import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import FuseHighlight from 'components/FuseHighlight/FuseHighlight'
import RequisitionCard from '../RequisitionCard/RequisitionCard'

import styles from './AppointmentCard.module.sass'

const AppointmentBody = (props) => {
	const { data, labels } = props
	const { openFile, i18n } = useGlobal()

	const DEFAULT_HISTORY = [
		{ observations: i18n`There are no additional changes` },
	]

	return (
		<div className={styles['details-container']}>
			{data.hasDocuments && (
				<ModalOptions
					title={labels.documents}
					options={data.documentsOptions}
					centerArrow
					fixedHeight='auto'
					alwaysAbove
					selectable={false}
					onSelect={(e) => {
						openFile && openFile(e)
						return true
					}}
				>
					<Icon className={styles['attachments']} name='attachment' />
				</ModalOptions>
			)}
			<div className={styles['inner-table']}>
				<span className={`${styles['cell']}`}>
					<h5>
						{labels.disability} / {labels.current}
					</h5>
					<div>
						<small className={styles['multi-line']}>
							{data.disability?.rateStr
								? `${data.disability?.rateStr} - `
								: ''}
							{data.disability?.abbreviation}
							{data.currentDisability
								? ` / ${data.currentDisability.abbreviation}`
								: ''}
						</small>
					</div>
				</span>
				<span className={`${styles['cell']}`}>
					<h5>{labels.diagnosis}</h5>
					<div>
						<small className={styles['multi-line']}>
							{data.medicalDiagnosis
								.map((data) => data.icd9Code)
								.join(', ')}
						</small>
					</div>
				</span>
			</div>
			{data.medicalObservation && (
				<>
					<h5 className={styles['observation-title']}>
						{labels.medicalObservation}
					</h5>
					<div dynamic='true' className={styles['observation']}>
						<div
							style={{
								minHeight:
									!isNaN(data.textHeight) &&
									data.textHeight > 0
										? data.textHeight
										: undefined,
								maxHeight:
									!isNaN(data.textHeight) &&
									data.textHeight > 0
										? data.textHeight
										: undefined,
							}}
						>
							<FuseHighlight
								matchedWords={
									data.$textHighlight?.matchedIndexes?.[
										'medicalObservation'
									]
								}
								text={data.medicalObservation}
							/>
						</div>
					</div>
				</>
			)}
			{data.$detailLevel !== 'detailed' && (
				<div className={styles['history-content']}>
					<span>
						<Icon
							className={styles['text-icon']}
							name='executed'
							width='16px'
							height='16px'
						/>
						<small className={styles['history-title']}>
							<strong>{labels.changesHistory}</strong>
						</small>
					</span>
					<div>
						{(data.history && data.history.length
							? data.history
							: DEFAULT_HISTORY
						).map((elem, idx) => {
							return (
								<div
									key={idx}
									className={styles['history-line']}
								>
									<span
										className={styles['history-circle']}
									/>
									<SlidingText
										className={styles['history-text']}
									>
										<small>
											{
												elem?.modificationDate
													?.dateTimeFormat
											}{' '}
											<strong>
												{elem?.modificationUser}
											</strong>{' '}
											{elem?.observations}
										</small>
									</SlidingText>
								</div>
							)
						})}
					</div>
				</div>
			)}
			{(data?.requisitions || []).map((elem, idx) => (
				<RequisitionCard
					key={idx}
					className={styles['requisition']}
					data={elem}
				/>
			))}
		</div>
	)
}

export default AppointmentBody

export const AppointmentBodySkeleton = () => (
	<div className={styles['details-container-skeleton']}>
		<div className={styles['table']}>
			<span className={`${styles['cell']}`}>
				<div className={styles['inner-table']}>
					<span className={`${styles['cell']}`}>
						<h5>
							<Skeleton
								className={`${styles['skeleton']} ${styles['small']}`}
							/>
						</h5>
						<div>
							<small className={styles['multi-line']}>
								<Skeleton
									className={`${styles['skeleton']} ${styles['small']}`}
								/>
							</small>
						</div>
					</span>
					<span className={`${styles['cell']}`}>
						<h5>
							<Skeleton
								className={`${styles['skeleton']} ${styles['small']}`}
							/>
						</h5>
						<div>
							<small className={styles['multi-line']}>
								<Skeleton
									className={`${styles['skeleton']} ${styles['small']}`}
								/>
							</small>
						</div>
					</span>
					<span className={`${styles['cell']}`}>
						<h5>
							<Skeleton
								className={`${styles['skeleton']} ${styles['small']}`}
							/>
						</h5>
						<div>
							<small className={styles['multi-line']}>
								<Skeleton
									className={`${styles['skeleton']} ${styles['small']}`}
								/>
							</small>
						</div>
					</span>
				</div>
			</span>
		</div>
	</div>
)
